var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component"},[_vm._l((_vm.bgImgs),function(item){return _c('div',{key:item.url,staticClass:"img",style:({
      backgroundImage: ("url(" + (item.url) + ")"),
      height: ((item.height) + "px"),
    })})}),_vm._v(" "),_c('div',{staticClass:"img",style:({
      position: 'absolute',
      zIndex: -1,
      top: 0,
      left: 0,
      backgroundImage: ("url(" + (_vm.imgInfo.url) + ")"),
      height: ((_vm.imgInfo.height) + "px"),
    })})],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5008ad0a","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/index.vue
// module id = 22
// module chunks = 1